module.exports = __webpack_public_path__ + "static/media/date_range.d90ba04b.svg";